"use client";

import { WarningIcon } from "@phosphor-icons/react";
import { type ReactElement, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { Typography } from "@/components/ui/typography";
import { useTranslation } from "@/i18n/client";

const MAINTENANCE_END = Date.parse("2026-10-13T22:00:00-05:00");
const WARNING_ICON_SIZE = 20;

export function MaintenanceBanner(): ReactElement | null {
  const { t } = useTranslation("maintenance-banner");
  const [visible, setVisible] = useState(false);

  useEffect(function scheduleVisibility(): (() => void) | undefined {
    const remaining = MAINTENANCE_END - Date.now();
    if (remaining <= 0) {
      return;
    }

    setVisible(true);
    const timeout = window.setTimeout(function hideBanner() {
      setVisible(false);
    }, remaining);

    return function cleanup(): void {
      window.clearTimeout(timeout);
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <aside
      aria-live="polite"
      className="w-full rounded-xl bg-warning-100 border border-warning-400 px-4 py-3 flex items-start gap-3 mb-4"
    >
      <WarningIcon
        size={WARNING_ICON_SIZE}
        aria-hidden="true"
        className="text-warning-600 shrink-0 mt-0.5"
        weight="fill"
      />
      <Typography variant="label 5" className="text-warning-600 flex-1">
        <Trans i18nKey="message" t={t} components={{ strong: <strong /> }} />
      </Typography>
    </aside>
  );
}
